import React, {useEffect, useState} from 'react'
import {
  IPricingTable,
  pricingTableInitValues as initialValues,
} from '../../models/PricingTableModel'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation, useParams, useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Calendar} from 'primereact/calendar'
import moment from 'moment'

const API_URL = process.env.REACT_APP_API_URL || 'api'

export interface UseOption {
  value: string
  label: string
}

const FormPricingTableEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const parametro = useParams()
  const {uuid, description, start_date, end_date} = location.state as IPricingTable
  const [start_dateD, setStart_dateD] = useState<Date | undefined>(undefined)
  const [end_dateD, setEnd_dateD] = useState<Date | undefined>(undefined)

  console.log('location.state ', location.state)
  useEffect(() => {
    formik.setFieldValue('uuid', uuid)
    formik.setFieldValue('description', description)
    if (start_date) {
      let initial = new Date(`${start_date} 12:00:00`)
      setStart_dateD(initial)
      formik.setFieldValue('start_date', start_date)
    }
    if (end_date) {
      let initial = new Date(`${end_date} 12:00:00`)
      setEnd_dateD(initial)
      formik.setFieldValue('end_date', end_date)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  // toda vez que a dependência é atualizada, o useEffect é chamado

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IPricingTable>({
    initialValues,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.put(
          `${API_URL}/sga/v1/issue_organs/${parametro.uuid}/pricing_tables/${uuid}`,
          values
        )
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PRICING.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate(`/editissueorgans/${parametro.uuid}`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PRICING.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  async function deletePricingTable(uuid: string) {
    await axios
      .delete(`${API_URL}/sga/v1/issue_organs/${parametro.uuid}/pricing_tables/${uuid}`)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PRICING.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate(`/editissueorgans/${parametro.uuid}`)
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title:
            intl.formatMessage({id: 'PRICING.SWAL_DELETE_ERROR'}) +
            ' erro = ' +
            error.response.data.message,
          confirmButtonColor: '#d33',
          showConfirmButton: true,
          confirmButtonText: intl.formatMessage({id: 'USER.SIGNOUT'}),
        })
      })
  }

  function deleteMsgPricingTable() {
    MySwal.fire({
      title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deletePricingTable(uuid)
      }
    })
  }
  const setConvertDate = (e: any, typeDate: 'start_date' | 'end_date') => {
    let DateFormate: any
    switch (typeDate) {
      case 'start_date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setStart_dateD(e)
        formik.setFieldValue('start_date', DateFormate)
        break
      }
      case 'end_date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setEnd_dateD(e)
        formik.setFieldValue('end_date', DateFormate)
        break
      }
    }
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      {/* <HeaderCard
        buttonBack={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
        title={intl.formatMessage({id: 'PRICING.NEW_PRICING_TABLE'})}
        routeBack={'/issueorgans/' + uuid + '/pricingtable/'}
      /> */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'PRICING.EDIT_PRICING_TABLE'})}
      </PageTitle>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO DESCRIÇÃO ----------------------*/}
            {/* INICIO DESCRIÇÃO ----------------------*/}
            <div className='row'>
              <div className='col-lg-6'>
                <label className='col-form-label required fw-bold'>
                  {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
                </label>
                <Calendar
                  onChange={(e: any) => setConvertDate(e.value, 'start_date')}
                  selectionMode='single'
                  inputClassName='form-control-calendar form-control form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                  value={start_dateD}
                />
              </div>
              <div className='col-lg-6'>
                <label className='col-form-label required fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_DATE_COMPLETION'})}
                </label>
                <Calendar
                  onChange={(e: any) => setConvertDate(e.value, 'end_date')}
                  value={end_dateD}
                  selectionMode='single'
                  inputClassName='form-control-calendar form-control form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                />
              </div>
            </div>

            <Input3
              title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              {...formik.getFieldProps('description')}
              type={'textarea'}
            />
            {/* FIM DESCRIÇÃO ------------------------------*/}
            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm  btn-primary me-2' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>

              <button
                type='button'
                onClick={deleteMsgPricingTable}
                className='btn btn btn-sm btn-outline btn-outline-danger btn-active-danger ml-3'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormPricingTableEdit}
